import React, { useEffect, useRef } from 'react';
import './Testimonials.css';

const testimonialsData = [
  {
    id: 1,
    name: 'Marcos Aurélio Souza',
    position: 'Assinante Plano 500 Mega',
    company: 'Bairro Sepetiba',
    location: 'Rio de Janeiro, RJ',
    text: 'Desde que troquei para a Faynet, minha internet nunca mais caiu. A velocidade é constante o dia todo, mesmo à noite quando todo mundo em casa está conectado.',
    rating: 5
  },
  {
    id: 2,
    name: 'Fernanda Lima',
    position: 'Assinante Plano Family Plus',
    company: 'Bairro Guaratiba',
    location: 'Rio de Janeiro, RJ',
    text: 'Trabalho de home office e a estabilidade da conexão faz toda diferença nas minhas videochamadas. Suporte super rápido sempre que precisei.',
    rating: 5
  },
  {
    id: 3,
    name: 'Ricardo Nogueira',
    position: 'Cliente há 3 anos',
    company: 'Bairro Santa Cruz',
    location: 'Rio de Janeiro, RJ',
    text: 'Já tive vários provedores e nenhum chegou perto do atendimento da Faynet. Quando dá algum problema, o técnico resolve rápido, sem enrolação.',
    rating: 5
  },
  {
    id: 4,
    name: 'Camila Duarte',
    position: 'Assinante Plano 1 Giga',
    company: 'Bairro Campo Grande',
    location: 'Rio de Janeiro, RJ',
    text: 'Jogo online todos os dias e nunca mais tive travamento ou ping alto. A internet 1 Giga da Faynet é excelente para quem precisa de velocidade de verdade.',
    rating: 5
  },
  {
    id: 5,
    name: 'João Batista Ferreira',
    position: 'Assinante Plano 300 Mega',
    company: 'Bairro Paciência',
    location: 'Rio de Janeiro, RJ',
    text: 'A instalação foi rápida e o técnico explicou tudo direitinho. Preço justo e conexão estável, exatamente o que minha família precisava.',
    rating: 5
  },
  {
    id: 6,
    name: 'Vanessa Cristina Alves',
    position: 'Assinante Plano Standard',
    company: 'Bairro Pedra de Guaratiba',
    location: 'Rio de Janeiro, RJ',
    text: 'Fiz a portabilidade em poucos dias e sem burocracia nenhuma. A Faynet realmente entrega o que promete: internet rápida e suporte de qualidade.',
    rating: 5
  }
];

function Testimonials() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
        }
      });
    }, observerOptions);

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="testimonials" ref={sectionRef}>
      <div className="testimonials__container">
        <div className="testimonials__header">
          <h2 className="testimonials__title">
            O que nossos <span className="testimonials__title--highlight">clientes dizem</span>
          </h2>
          <p className="testimonials__subtitle">
            Mais de 500 famílias confiam na Faynet para ter uma internet rápida, estável e com suporte de verdade
          </p>
        </div>

        <div className="testimonials__track-outer">
          <div className="testimonials__track">
            {[...testimonialsData, ...testimonialsData].map((testimonial, index) => (
              <div
                key={`${testimonial.id}-${index}`}
                className="testimonial-card"
              >
                <div className="testimonial-card__stars">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <span key={i} className="testimonial-card__star">★</span>
                  ))}
                </div>

                <p className="testimonial-card__text">"{testimonial.text}"</p>

                <div className="testimonial-card__author">
                  <div className="testimonial-card__avatar">
                    {testimonial.name.split(' ').map(n => n[0]).slice(0, 2).join('')}
                  </div>
                  <div className="testimonial-card__info">
                    <h4 className="testimonial-card__name">{testimonial.name}</h4>
                    <p className="testimonial-card__position">{testimonial.position}</p>
                    <p className="testimonial-card__company">{testimonial.company}</p>
                    <p className="testimonial-card__location">{testimonial.location}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
